exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mg-export{\n    margin-left: 15px !important;\n}\n\n@media (max-width: 414px){\n    .mg-export{\n        margin-left: 0px !important;\n        margin-top: -20px !important;\n        height: 60px;\n    }\n}", ""]);

// exports
